import React from 'react';
import { useChatMessaging } from './useChatMessaging';
import { useBrandedProModalQuery } from 'components/branded-pro-modal/BrandedProModalQuery';
import { useProgressBarData } from 'flows/core/hooks/use-progress-bar-data';
import { brandedModalQuery_siteBranding_entityBrandings } from 'types/generated/brandedModalQuery';

export function useVBAData(chatReadyState: string) {
  const chatMessages = useChatMessaging();
  const { data: brandingData } = useBrandedProModalQuery({
    variables: { input: {} },
  });
  const progressData = useProgressBarData();

  const propertyName = React.useMemo(() => {
    const branding = brandingData?.siteBranding?.entityBrandings?.find(
      (b: brandedModalQuery_siteBranding_entityBrandings | null | undefined) =>
        b?.showBranding
    );
    return branding?.name;
  }, [brandingData]);

  if (chatReadyState !== 'ready') {
    return {
      ...progressData,
      propertyName,
      handleSendMessage: async () => {},
      startNewConversation: () => {},
      flushPendingAssistantMessage: () => {},
      chatRef: chatMessages.chatRef,
      chatSessionKey: chatMessages.chatSessionKey,
      conversation: null,
      isLoading: false,
      isStartingNewConversation: false,
      messages: [],
      validConversation: undefined,
      pendingUserMessage: null,
      pendingAssistantMessage: null,
      animateLastAssistant: false,
      handleTypewriterDone: () => {},
    };
  }

  return {
    ...chatMessages,
    ...progressData,
    propertyName,
    messages: chatMessages.messages,
    validConversation: chatMessages.conversation
      ? { messages: (chatMessages.conversation.messages || []) as unknown[] }
      : undefined,
  };
}
